import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { ANONYM_USER, IS_BIZ_USER, IS_CORP_USER, IS_MOBILE_BROWSER, IS_REGULAR_USER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

type UpsaleForBusiness = 'a' | 'b' | false;

interface UpsaleForBusinessTariffs {
    month: string[];
    year: string[];
}

const isUspaleForBusiness: UpsaleForBusiness = getFeature('upsale-for-business');

const upasaleForBusinessTariffs: UpsaleForBusinessTariffs = getFeature('upsale-for-business-tariffs') || {
    month: [
        'W256GB_1m_business_discount',
        'W512GB_1m_business_discount',
        'W1TB_1m_business_discount',
        'W2TB_1m_business_discount',
        'W4TB_1m_business_discount',
    ],
    year: [
        'W256GB_1y_business_discount',
        'W512GB_1y_business_discount',
        'W1TB_1y_business_discount',
        'W2TB_1y_business_discount',
        'W4TB_1y_business_discount',
    ],
};

export const upsaleForBusiness = {
    enabled: (isOverquotaUser: boolean) =>
        isUspaleForBusiness === 'b' &&
        !IS_WEBVIEW &&
        !IS_MOBILE_BROWSER &&
        !IS_BIZ_USER &&
        !isOverquotaUser &&
        (IS_REGULAR_USER || ANONYM_USER) &&
        !IS_CORP_USER,
    tariffs: upasaleForBusinessTariffs,
} as const;

registerExperiment(
    'upsale-business',
    isUspaleForBusiness,
    [
        AnalyticEventNames.UPSALE_MULTI_MODAL_SHOW,
        AnalyticEventNames.UPSALE_MULTI_MODAL_SWITCH,
        AnalyticEventNames.UPSALE_MULTI_MODAL__CONTINUE,
        AnalyticEventNames.UPSALE_MULTI_MODAL_CLOSE,
    ],
    {
        mapEventNames: {
            UPSALE_MULTI_MODAL_SHOW: 'show',
            UPSALE_MULTI_MODAL_SWITCH: 'switch',
            UPSALE_MULTI_MODAL__CONTINUE: 'continue',
            UPSALE_MULTI_MODAL_CLOSE: 'close',
        },
    }
);
